var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table__body"},_vm._l((_setup.props?.dado?.recebimentos),function(recebimento){return _c(_setup.LinhaDeRecebimentos,{key:recebimento.id,attrs:{"dado":_setup.props?.dado,"recebimento":recebimento},on:{"update:alteraRecebimento":_setup.alteraRecebimento}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }